// removed by extract-text-webpack-plugin
module.exports = {"grey":"_2bKWzjhY","inventoryList":"_1ifoKwNm"};


//////////////////
// WEBPACK FOOTER
// ./app/orders/containers/container-stock/container-stock.styles.scss
// module id = 706
// module chunks = 0